import { AxiosError } from 'axios'
import { Box, Flex } from 'components/elements'
import { Modal } from 'components/modal'
import { ModalEnum } from 'features/incidents/components/enums'
import { useChangePaymentMethod } from 'features/insurance/api/changePaymentMethod'
import { ErrorBox } from 'features/profile/components/EditProfileForm'
import StripePayment from 'features/stripe/components/StripePayment'
import StripeComponent from 'features/stripe/page/StripeComponent'
import { useState } from 'react'
import { errorMessage, getUpperCase } from 'utils/function'

type ChangePaymentMethodProps = {
  openModal: { label: string; isOpen: boolean }
  setOpenModal: (value: { label: string; isOpen: boolean }) => void
  setNotification: (value: string) => void
}

const ChangePaymentMethod = (props: ChangePaymentMethodProps) => {
  const { openModal, setOpenModal, setNotification } = props
  const [submitError, setSubmitError] = useState('')
  const { mutate, isLoading } = useChangePaymentMethod()
  const IsOpenInModal = true

  const handleStripeSubmit = (paymentMethodId: string) => {
    const obj = {
      paymentMethodId,
      isAutoSubscriptionEnabled: true,
    }
    mutate(obj, {
      onSuccess: () => {
        setOpenModal({ label: '', isOpen: false })
        setNotification(ModalEnum.CHANGE_PaymentMethod)
      },
      onError: error => {
        if (error instanceof AxiosError) {
          setSubmitError(errorMessage(error))
        }
      },
    })
  }
  const handleCancel = () => {
    props?.setOpenModal && props?.setOpenModal({ label: '', isOpen: false })
  }
  return (
    <>
      <Modal
        active={openModal.label === ModalEnum.CHANGE_PaymentMethod && openModal.isOpen}
        hideModal={() => {
          setOpenModal({ label: '', isOpen: false })
        }}
        title=" Change Card Details"
        description={''}
        isFooterHidden={true}
        children={
          <>
            <Box as="h4" css={{ textAlign: 'start' }}>
              Card Information
            </Box>
            {!!submitError && <ErrorBox css={{ textAlign: 'left', mb: '$3' }}>{getUpperCase(submitError)}</ErrorBox>}
            <Flex direction="column" css={{ gap: '$5' }}>
              <StripeComponent
                WrappedComponent={() => (
                  <StripePayment onSubmit={handleStripeSubmit} isLoading={isLoading} IsOpenInModal={IsOpenInModal} isChangedCard={true} handleCancel={handleCancel} />
                )}
              />
            </Flex>
          </>
        }
        acceptText={''}
      />
    </>
  )
}

export default ChangePaymentMethod
